module.exports = __webpack_public_path__ + "img/04.鹿型柏（杨树田-摄）.86012e4a.jpg";